﻿import * as IdiPageSpinner from "./idiPageSpinner/idiPageSpinner.directive";
import * as IdiViewSpinner from "./idiViewSpinner/idiViewSpinner.directive";
import * as IdiMediumSpinner from "./idiMediumSpinner/idiMediumSpinner.directive";
import { yesNoSelect } from './yesNoSelect/yesNoSelect.directive';
import { idiNumericInput } from './idiNumericInput/idiNumericInput.directive';
import RecaptchaModule from "./recaptcha/recaptcha.module";
import { validationDecorator } from './validationDecorator/validationDecorator.directive';

export default angular.module('idi.marketplace.directives', [RecaptchaModule])

    .directive("idiPageSpinner", IdiPageSpinner.idiPageSpinner.factory())
    .directive("idiViewSpinner", IdiViewSpinner.idiViewSpinner.factory())
    .directive("idiMediumSpinner", IdiMediumSpinner.idiMediumSpinner.factory())
    .directive('yesNoSelect', yesNoSelect.factory())
    .directive('idiNumericInput', idiNumericInput.factory())
    .directive('validationDecorator', validationDecorator.factory())
    .name;
